<template>
    <div v-if="content.length">
        <div class="product-book-container" v-if="item.info.length" v-for="item in content">
            <div class="product-book-title">{{item.title}}</div>
            <div :class="item.searchType !== 'productManual'?'items course':'items'">
                <div class="item" v-for="subItem in item.info" @click="viewDetail(subItem,item)">
                    <img :src="subItem.cover"
                         class="cover"/>
                    <span class="name">{{subItem.title}} </span>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "TemplateContainer",
        props: { content: Array},
        methods:{
            viewDetail(subItem,item){
                // 如果是课程这个地方关联的手册，反之亦然
                if(item.searchType != 'productManual'){
                    const preRouterName = this.$router.currentRoute.name
                    window.open(`${origin}/#/service-center/detail?id=${subItem.id}&type=liveCourse&currentRoute=${preRouterName}`)
                }else{
                    const preRouterName = this.$router.currentRoute.name
                    window.open(`${origin}/#/service-center/detail?id=${subItem.id}&type=productManual&currentRoute=${preRouterName}`)
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .product-book-container {
        width: 727px;
        background: #FFFFFF;
        box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.05);
        border-radius: 3px;
        padding: 19px 24px;
        margin: 30px 0;
        .template-title{
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            color: #444444;
        }
        .product-book-title {
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            color: #444444;
        }

        .items {
            margin-top: 20px;
            &.course{
                .item{
                    .cover{
                        width: 144px;
                        height: 80px;
                        margin-left: 0;
                    }
                }
            }
            .item{
                display: inline-block;
                width: 160px;
                text-align: center;
                margin-right: 50px;
                cursor: pointer;
                .cover{
                    width: 68px;
                    height: 96px;
                    display: block;
                    margin: auto;
                }
                .name{
                    margin-top: 10px;
                    font-size: 12px;
                    line-height: 17px;
                    color: #444444;
                    display: block;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                    max-width: 160px;
                    text-align: left;
                }
            }
        }
    }
</style>